import React, { useState } from "react";
import { Row, Col, Form, Card, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Avatar from "../../../assets/img/default.jpg";
import {
  createUser,
  fileUpload,
  UpdateUserProfile,
} from "../../../api/userService";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import { addUserSchema } from "../../../validations/authSchema";
export default function Adduser() {
  const [previewUrl, setPreviewUrl] = useState(Avatar);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
      if (!validTypes.includes(file.type)) {
        toast.error("Only image files (jpg, png, gif, webp) are allowed.");
        return;
      }

      setProfilePic(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };
  const navigate = useNavigate();
  const [profilePic, setProfilePic] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(addUserSchema),
  });

  const onUserSubmit = async (data) => {
    try {
      const createRes = await createUser(data);

      if (createRes.code !== 200 || !createRes.data?._id) {
        toast.error(createRes.message || "User creation failed");
        return;
      }

      const userId = createRes.data._id;

      if (profilePic) {
        const formData = new FormData();
        formData.append("document", profilePic);
        formData.append("folderPath", `${userId}/Profile`);

        const uploadRes = await fileUpload(formData);

        if (uploadRes?.status && uploadRes?.data?.url) {
          const imageUrl = uploadRes.data.url;
          const updateForm = new FormData();
          updateForm.append("profilePic", imageUrl);
          await UpdateUserProfile(userId, updateForm);
        }
      }

      toast.success("User created successfully");
      navigate("/users");
      reset();
    } catch (err) {
      toast.error(err.message || "User creation failed");
    }
  };

  return (
    <React.Fragment>
      <Card>
        <Card.Header className="d-flex align-items-center justify-content-between flex-wrap">
          <h5>Add User</h5>
          <Link
            className="btn btn-primary-light d-inline-flex align-items-center justify-content-center px-4 min_width140"
            to="/Users"
          >
            Back
          </Link>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit(onUserSubmit)}>
            <Row className="mt-3">
              <Col md={5} xl={4} className="view_profile mb-3">
                <div className="user_info text-center">
                  <div className="d-flex align-items-center justify-content-center">
                    <img
                      src={previewUrl}
                      className="rounded-circle img-fluid profilepic"
                      alt="Profile Preview"
                    />
                  </div>
                  <label
                    htmlFor="uploadprofileimg"
                    className="d-inline-block mt_30 btn btn-primary-outline px-4 font-size-14 lh-40"
                  >
                    Choose Picture
                  </label>
                  <input
                    type="file"
                    id="uploadprofileimg"
                    className="d-none"
                    accept=".jpg,.jpeg,.png,.webp"
                    onChange={handleFileChange}
                  />
                </div>
              </Col>
              <Col md={7} xl={8}>
                <Row>
                  <Col lg={6}>
                    <Form.Group className="form-group mb-3">
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter name"
                        {...register("fullName")}
                        isInvalid={!!errors.fullName}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.fullName?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="form-group mb-3">
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter email address"
                        {...register("email")}
                        isInvalid={!!errors.email}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={12}>
                    <Form.Group className="form-group mb-3">
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter phone number"
                        {...register("mobileNumber")}
                        isInvalid={!!errors.mobileNumber}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.mobileNumber?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="form-group mb-3">
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        {...register("accountStatus")}
                        isInvalid={!!errors.accountStatus}
                      >
                        <option value="select">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.accountStatus?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="form-group mb-3">
                      <Form.Label>Subscription Status</Form.Label>
                      <Form.Select
                        {...register("subscriptionStatus")}
                        isInvalid={!!errors.subscriptionStatus}
                      >
                        <option value="select">
                          Select Subscription Status
                        </option>
                        <option value="Free">Free</option>
                        <option value="Basic">Basic</option>
                        <option value="Premium">Premium</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.subscriptionStatus?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={12}>
                    <Form.Group className="form-group mb-3">
                      <Form.Label>Bio</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="Enter here..."
                        {...register("bio")}
                        isInvalid={!!errors.bio}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.bio?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Button
                  type="submit"
                  className="btn btn-primary px-4 mt-3 min_width140"
                >
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </React.Fragment>
  );
}
